import { useCallback, useEffect, useState } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { FloatingCTA } from "./components/FloatingCTA";
import { ContactModal } from "./components/ContactModal";
import { HomePage } from "./pages/HomePage";
import { PricingPage } from "./pages/PricingPage";
import { useScrollReveal } from "./hooks/useScrollReveal";
import { useHashScroll } from "./hooks/useHashScroll";

export function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = useCallback(() => setModalOpen(true), []);
  const closeModal = useCallback(() => setModalOpen(false), []);

  useScrollReveal();
  useHashScroll();

  useEffect(() => {
    document.body.style.overflow = modalOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [modalOpen]);

  return (
    <>
      <Header onBook={openModal} />
      <main>
        <Routes>
          <Route element={<Outlet context={{ openModal }} />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/pricing" element={<PricingPage />} />
          </Route>
        </Routes>
      </main>
      <Footer onBook={openModal} />
      <FloatingCTA onBook={openModal} />
      <ContactModal open={modalOpen} onClose={closeModal} />
    </>
  );
}
